var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilebuttonicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.029,
    height: 16.029,
    viewBox: "0 0 16.029 16.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ec6321;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.375,11.389a8.014,8.014,0,1,0,8.014-8.014A8.013,8.013,0,0,0,3.375,11.389ZM14.514,9.717a.747.747,0,0,1,1.052,0,.735.735,0,0,1,.216.524.747.747,0,0,1-.22.528l-3.633,3.622a.743.743,0,0,1-1.025-.023L7.217,10.692A.744.744,0,0,1,8.268,9.64L11.393,12.8Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilebuttonicon);
export default __webpack_public_path__ + "static/media/profile button icon.5c005fa4ce7903e49654a238d44d9591.svg";
export { ForwardRef as ReactComponent };